import { BodyText } from '@unmind/design-system';
import { HeadingText } from 'Shared/Typography';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

const BasePillStyles = css`
  display: inline-flex;
  align-items: center;
  height: ${rem(24)};
  padding: ${rem(5)} ${rem(12)};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${rem(16)};
`;

export const Label = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
}))``;

export const Subheader = styled(HeadingText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.bold,
  lineHeight: theme.typography.lineHeights.lineHeight16,
  color: theme.colors.text.primary,
  level: 3,
}))`
  margin-top: ${rem(24)};
`;

export const PillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${rem(16)};
  gap: ${rem(8)};
`;

export const Pill = styled.div`
  ${BasePillStyles}
`;
